import { HttpClient } from '@angular/common/http';
import { Injectable, signal, inject } from '@angular/core';
import { ApiUrl, IrisApiClient } from '@iris/api-query';
import { Observable, catchError, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IrisUserService } from '@iris/common/services/user.service';

export interface IrisSiaUrlParamsI {
  strathekNumber?: string;
  maxSelectedPhotos?: number;
  noSelect?: boolean;
}

@Injectable()
@ApiUrl('/dms2/{iris@instanceId}/sia')
export class IrisSiaService extends IrisApiClient<unknown> {
  protected readonly httpClient: HttpClient;
  protected readonly userService = inject(IrisUserService);

  private readonly baseSiaUrlPart = '/front/ui/utility/iris-entry/';

  readonly allowedDomain = signal('');
  
  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient);
  
    this.httpClient = httpClient;
  }
  @ApiUrl('~/url')
  generateSiaUrl(params: IrisSiaUrlParamsI): Observable<string> {
    return this.httpClient.get(this.url(), { responseType: 'text' }).pipe(
      map((url: string) => {
        const origin = new URL(url).origin;
        this.allowedDomain.set(origin);
        return [origin, this.baseSiaUrlPart, '?', this.getBaseSiaUrlParams(params).toString()].join('');
      }),
      catchError(() => of('')),
    );
  }

  isDomainAllowed(origin: string): boolean {
    return this.allowedDomain() === origin;
  }

  private getBaseSiaUrlParams(params: IrisSiaUrlParamsI): URLSearchParams {
    const langCode = this.userService.me.language;
    const result = new URLSearchParams({
      isIFrame: 'true',
      consumer: 'pmh',
      lang: langCode,
    });
    if (params.maxSelectedPhotos) {
      result.set('max_selected_photos', params.maxSelectedPhotos.toString());
    }
    if (params.strathekNumber) {
      result.set('strathek_number', params.strathekNumber);
    }
    if (params.noSelect) {
      result.set('noSelect', 'true');
    }
    return result;
  }
}
